import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { Box, Button, Heading, Text } from '@components/common';
import { InputField } from '@components/form';
import API from '@utils/api';
import history from '@utils/history';
import { getErrors } from '@utils/error';

import validationSchema from './schema';
import AuthActions from '@redux/AuthRedux';
import AppActions, { LOGIN_PAGES } from '@redux/AppRedux';

class ResetForm extends React.Component {
  static propTypes = {
    email: PropTypes.string,
    resetToken: PropTypes.string,
    onSubmit: PropTypes.func
  };

  handleSubmit = async (values, actions) => {
    const { email, resetToken, onSubmit } = this.props;
    const { setSubmitting, setErrors, setStatus } = actions;
    setSubmitting(true);

    try {
      await API.resetPassword({
        resetHash: resetToken,
        ...values
      });

      setStatus({
        message: 'Password is updated'
      });

      const { result: token } = await API.loginWithEmail({
        email,
        password: values.password
      });

      onSubmit(token);

      setSubmitting(false);
    } catch (err) {
      const error = getErrors(err);
      if (error.message) {
        setErrors({
          passwordConfirmation: error.message
        });
      } else {
        setErrors(error);
      }
    }
    setSubmitting(false);
  };

  render() {
    const { email } = this.props;

    return (
      <Formik
        initialValues={{ password: '', passwordConfirmation: '' }}
        onSubmit={this.handleSubmit}
        validationSchema={validationSchema}
      >
        {({ isValid, isSubmitting }) => {
          return (
            <Form>
              <Box display="flex" flexDirection="column">
                <Heading>Create Your Password</Heading>

                {status && status.message ? (
                  <React.Fragment>
                    <Text px={2} mb={4}>
                      {status.message}
                    </Text>
                    <Button
                      flex={1}
                      mb={4}
                      type="button"
                      onClick={() => {
                        history.push('/auth/login');
                      }}
                    >
                      Continue
                    </Button>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Text px={2} mb={4}>
                      Choose a new password for {email}
                    </Text>
                    <Field
                      component={InputField}
                      mb={4}
                      name="password"
                      type="password"
                      label="New Password"
                    />
                    <Field
                      component={InputField}
                      mb={4}
                      name="passwordConfirmation"
                      type="password"
                      label="Confirm Password"
                    />
                    <Button
                      flex={1}
                      mb={4}
                      type="submit"
                      disabled={!isValid || isSubmitting}
                    >
                      Continue
                    </Button>
                  </React.Fragment>
                )}
              </Box>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  onSubmit: token => {
    dispatch(AuthActions.setLoggedIn(token));
    dispatch(AppActions.setAppDataLoadRequest(LOGIN_PAGES.RESET));
  }
});

export default connect(
  null,
  mapDispatchToProps
)(ResetForm);
